import { render, staticRenderFns } from "./ForMarkOnly.vue?vue&type=template&id=13e4876f&scoped=true&"
import script from "./ForMarkOnly.vue?vue&type=script&lang=js&"
export * from "./ForMarkOnly.vue?vue&type=script&lang=js&"
import style0 from "./ForMarkOnly.vue?vue&type=style&index=0&id=13e4876f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4876f",
  null
  
)

export default component.exports